module.exports = __webpack_public_path__ + "img/close.83cf1939.svg";